import React from 'react'
import { useTranslation } from 'react-i18next'
import { H2, List, Separator, Subheading } from '@fs/zion-ui'
import { useSlsStateContext } from '@fs/zion-sls'
import Droppable from '../../../../../views/indexing/components/ui/Droppable'
import PersonListItem from './PersonListItem'
import { formatRecordDisplayData, getHeadOfHouseholdName } from '../../../householdList/utils/record.utils'
import { droppableContainerCss, activeBorderCss } from '../utils/style.utils'

const DroppableHousehold = ({ record, dragInfo }) => {
  const [t] = useTranslation()
  const { currentImageArk } = useSlsStateContext()

  const persons = record?.subElements?.filter(
    (sub) => sub?.elementType === 'PERSON' && sub?.partitionKey === currentImageArk
  )

  if (!persons || persons.length === 0) {
    return null
  }

  const primaryPersonName = getHeadOfHouseholdName(record)
  const { primaryEventSummary } = formatRecordDisplayData(record)
  const householdHeading = primaryPersonName
    ? t('edit-household.household-with-name', '{primaryPersonName} Household', { primaryPersonName })
    : t('edit-household.household', 'Household')

  const getOverStyle = (isOver, over) => {
    if (!dragInfo?.isDragging) {
      return undefined
    }
    if (isOver && over?.id !== dragInfo?.person?.recordId) {
      return activeBorderCss
    }
    return droppableContainerCss
  }

  return (
    <Droppable id={record?.id} setOverStyle={getOverStyle}>
      <H2 size="H5">
        {householdHeading}
        {primaryEventSummary && <Subheading>{primaryEventSummary}</Subheading>}
      </H2>
      <Separator size="xxs" />
      <List>
        {persons.map((person) => (
          <PersonListItem key={person?.id} person={person} record={record} dragInfo={dragInfo} />
        ))}
      </List>
    </Droppable>
  )
}

export default DroppableHousehold
